import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { traceMetadata } from '../data/mockData';

const TraceContext = createContext(null);

export const TraceProvider = ({ children }) => {
  const [pidTraceMode, setPidTraceMode] = useState(false);
  const [currentRouteTrace, setCurrentRouteTrace] = useState(null);
  const [selectedComponentTrace, setSelectedComponentTrace] = useState(null);
  const [traceInspectorOpen, setTraceInspectorOpen] = useState(false);

  const toggleTraceMode = useCallback(() => {
    setPidTraceMode(prev => !prev);
  }, []);

  const updateRouteTrace = useCallback((pathname) => {
    const trace = traceMetadata[pathname] || traceMetadata['/'];
    setCurrentRouteTrace({
      pathname,
      ...trace
    });
  }, []);

  const openTraceInspector = useCallback((componentTrace = null) => {
    setSelectedComponentTrace(componentTrace);
    setTraceInspectorOpen(true);
  }, []);

  const closeTraceInspector = useCallback(() => {
    setTraceInspectorOpen(false);
    setSelectedComponentTrace(null);
  }, []);

  // Keyboard shortcut: Ctrl+Shift+P to toggle PID Trace Mode
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'P') {
        e.preventDefault();
        toggleTraceMode();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggleTraceMode]);

  const value = {
    pidTraceMode,
    toggleTraceMode,
    currentRouteTrace,
    updateRouteTrace,
    selectedComponentTrace,
    setSelectedComponentTrace,
    traceInspectorOpen,
    openTraceInspector,
    closeTraceInspector
  };

  return (
    <TraceContext.Provider value={value}>
      {children}
    </TraceContext.Provider>
  );
};

export const useTrace = () => {
  const context = useContext(TraceContext);
  if (!context) {
    throw new Error('useTrace must be used within a TraceProvider');
  }
  return context;
};

export default TraceContext;
